import {Component, OnInit} from '@angular/core';
import {AuthService} from '../auth-service';
import {User} from 'oidc-client-ts';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-user-profile',
  imports: [LocalizationPipePipe],
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.scss'
})
export class UserProfile implements OnInit {
  private _user: User | null = null;
  private _roles: string[] = []

  constructor(private readonly authService: AuthService) {
  }

  ngOnInit(): void {
    this.authService.user$.subscribe(u => {
      this._user = u;
      this._roles = this.authService.roles

      console.log(this._user, this._roles)
      console.log(this._user?.profile)
    })
  }


  get user(): User | null {
    return this._user;
  }

  get roles(): string[] {
    return this._roles;
  }

  get insuranceCompany(): string {
    return (this.user?.profile?.['custom:insurance_company_id'] ?? '') as string;
  }

  get lossAdjusterCompany(): string {
    return (this.user?.profile?.['custom:adjuster_company_id'] ?? '') as string;
  }

  get commitId(): string {
    return environment.buildInfo?.commitId || 'unknown';
  }

  get commitIdShort(): string {
    const fullCommitId = this.commitId;
    if (fullCommitId.startsWith('release-')) {
      return fullCommitId;
    } else if (fullCommitId !== 'unknown') {
      return fullCommitId.substring(0, Math.min(fullCommitId.length, 15));
    } else {
      return fullCommitId;
    }
  }

  get buildDate(): string {
    const buildDate = environment.buildInfo?.buildDate;
    return buildDate ? new Date(buildDate).toLocaleString() : 'unknown';
  }

  get version(): string {
    return environment.buildInfo?.version || '0.0.0';
  }
}
